import { createAction, props, union } from '@ngrx/store';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
/* eslint-disable max-len */

export const error = createAction('[Shared / Auth] Error', props<{ error: SharedErrorObjectI }>());
export const reset = createAction('[Shared / Auth] Reset', props<Record<string, unknown>>());
export const signOut = createAction('[Shared / Auth] Out load', props<Record<string, unknown>>());
export const signedIn = createAction('[Shared / Auth] In OK', props<{ username: string }>());
export const signingIn = createAction('[Shared / Auth] In load', props<Record<string, unknown>>());

const all = union({
  error,
  reset,
  signOut,
  signedIn,
  signingIn,
});
export type Actions = typeof all;
